import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InventoryHistory from "../components/InventoryHistory";

const InventoryHistoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Inventory History' />

        <InventoryHistory />

      </MasterLayout>
    </>
  );
};

export default InventoryHistoryPage;
